import {DurationFacilityReserveAvailability} from './ARReservationStatusViewDuration'
import moment, {Moment} from 'moment'
import AdminReservationTimelineView, {AdminTimelineItem} from '../../AdminReservationTimelineView'
import {Id} from '../../../components/ReservationTimelineView'
import React, {ReactNode} from 'react'
import {Box, Table, TableBody, TableCell, TableRow} from '@mui/material'
import {TableRowName} from '../../../../../styledComponents/adminPage/Table'
import PPTextField from '../../../../shared/forms/PPTextField'
import {
    FullWidthLeftColumnFlexContainer,
    FullWidthRowFlexContainer,
    RowFlexContainer,
} from '../../../../../styledComponents/FlexComponents'
import PPSelect from '../../../../shared/forms/PPSelect'
import {HOURS, RESERVATION_TIME_UNIT_MINUTES, RESERVATION_TYPE} from '../../../../../CodeMaster'
import PPDatePicker from '../../../../shared/forms/PPDatePicker'
import {formatDateWithDayOfTheWeek} from '../../../../../formatters/formatMoment'
import {Nullable, Optional} from '../../../../../app/TypeHelpers'
import FormErrorMessage from '../../../../shared/forms/FormErrorMessage'
import {FitTableCell, Section} from './ARStyledComponents'
import {Messages} from '../../../../../Messages'
import {ReservationClass} from '../../../ReservationInterfaces'
import {SelectChangeEvent} from '@mui/material/Select'

interface Props {
    classification: ReservationClass
    reservationType: Nullable<RESERVATION_TYPE>
    facilityWithAvailability: DurationFacilityReserveAvailability
    activeDay: moment.Moment
    initialVisibleStartDateTime: moment.Moment
    currentItem: AdminTimelineItem
    reservationTitle: string
    holidays: string[]
    onChangeReservationTitle: (title: string) => void
    onChangeReservationTerm: (currentItem: AdminTimelineItem) => void
    onClickTimeline: (groupId: Id, itemId: Id | null, time: moment.Moment) => void
}

class ARSelectFacilityInputFormDuration extends React.Component<Props> {

    initialDateTime: Nullable<moment.Moment> = null

    constructor(props: Readonly<Props>) {
        super(props)
        this.handleChangeReserveTitle = this.handleChangeReserveTitle.bind(this)
        this.handleChangeStartHour = this.handleChangeStartHour.bind(this)
        this.handleChangeStartMinute = this.handleChangeStartMinute.bind(this)
        this.handleChangeEndDate = this.handleChangeEndDate.bind(this)
        this.handleChangeEndHour = this.handleChangeEndHour.bind(this)
        this.handleChangeEndMinute = this.handleChangeEndMinute.bind(this)
    }

    componentDidMount(): void {
        this.initialDateTime = this.props.initialVisibleStartDateTime
    }

    handleChangeReserveTitle(event: React.ChangeEvent<HTMLInputElement>): void {
        this.props.onChangeReservationTitle(event.target.value)
    }

    handleChangeStartHour(event: SelectChangeEvent<unknown>): void {
        const {onChangeReservationTerm, currentItem} = this.props
        const startHour = event.target.value as string
        onChangeReservationTerm(
            {
                ...currentItem,
                start_time: moment(currentItem.start_time).hour(Number(startHour)).valueOf(),
            },
        )
    }

    handleChangeStartMinute(event: SelectChangeEvent<unknown>): void {
        const {onChangeReservationTerm, currentItem} = this.props
        const startMinute = event.target.value as string
        onChangeReservationTerm(
            {
                ...currentItem,
                start_time: moment(currentItem.start_time).minute(Number(startMinute)).valueOf(),
            },
        )
    }

    handleChangeEndDate(date: Nullable<Date>): void {
        if (date === null) {
            return
        }
        const {onChangeReservationTerm, currentItem} = this.props

        onChangeReservationTerm(
            {
                ...currentItem,
                end_time: moment(currentItem.end_time)
                    .year(date.getFullYear())
                    .month(date.getMonth())
                    .date(date.getDate())
                    .valueOf(),
            },
        )
    }

    handleChangeEndHour(event: SelectChangeEvent<unknown>): void {
        const {onChangeReservationTerm, currentItem} = this.props
        const endHour = event.target.value as string
        onChangeReservationTerm(
            {
                ...currentItem,
                end_time: moment(currentItem.end_time).hour(Number(endHour)).valueOf(),
            },
        )
    }

    handleChangeEndMinute(event: SelectChangeEvent<unknown>): void {
        const {onChangeReservationTerm, currentItem} = this.props
        const endMinute = event.target.value as string
        onChangeReservationTerm(
            {
                ...currentItem,
                end_time: moment(currentItem.end_time).minute(Number(endMinute)).valueOf(),
            },
        )
    }

    render(): ReactNode {
        const {
            classification, currentItem, activeDay, facilityWithAvailability, initialVisibleStartDateTime,
            reservationTitle, reservationType,
            onClickTimeline, holidays
        } = this.props
        const startDateTime: Moment = moment(currentItem.start_time)
        const endDateTime: Moment = moment(currentItem.end_time)
        const errorMessage: Optional<string> = convertToErrorMessage(currentItem.error)
        return <>
            <Box sx={{pt: '8px'}}>
                <Table>
                    <TableBody>
                        <TableRow>
                            <FitTableCell colSpan={2}>
                                <Section>{facilityWithAvailability.name}</Section>
                                <Box mt={'10px'}>
                                    <AdminReservationTimelineView
                                        activeDay={activeDay}
                                        initialVisibleStartDateTime=
                                            {this.initialDateTime || initialVisibleStartDateTime}
                                        areaWidth={912}
                                        limitStartDateTime={activeDay.clone().hour(0).minute(0)}
                                        limitEndDateTime={activeDay.clone().hour(23).minute(59)}
                                        onTimelineClick={onClickTimeline}
                                        groups={[{
                                            id: facilityWithAvailability.id,
                                            title: facilityWithAvailability.name
                                        }]}
                                        items={facilityWithAvailability.timeLineItems}
                                        sidebarProps={{pcWidth: 0, spWidth: 0}}
                                        hideGroup
                                    />
                                </Box>
                            </FitTableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>利用日時</TableRowName>
                            <TableCell>
                                <FullWidthLeftColumnFlexContainer>
                                    <FullWidthRowFlexContainer>
                                        <div>{formatDateWithDayOfTheWeek(startDateTime)}</div>
                                        <div>
                                            <RowFlexContainer>
                                                <div>
                                                    <PPSelect
                                                        data={HOURS.values()}
                                                        value={startDateTime.hour()}
                                                        onChange={this.handleChangeStartHour}
                                                    />
                                                </div>
                                                <div>：</div>
                                                <div>
                                                    <PPSelect
                                                        data={RESERVATION_TIME_UNIT_MINUTES.values()}
                                                        value={startDateTime.minute()}
                                                        onChange={this.handleChangeStartMinute}
                                                    />
                                                </div>
                                            </RowFlexContainer>
                                        </div>
                                        <div>〜</div>
                                        <div>
                                            <PPDatePicker
                                                value={endDateTime.toDate()}
                                                holidays={holidays}
                                                onChangeDate={this.handleChangeEndDate}
                                            />
                                        </div>
                                        <div>
                                            <RowFlexContainer>
                                                <div>
                                                    <PPSelect
                                                        data={HOURS.values()}
                                                        value={endDateTime.hour()}
                                                        onChange={this.handleChangeEndHour}
                                                    />
                                                </div>
                                                <div>：</div>
                                                <div>
                                                    <PPSelect
                                                        data={RESERVATION_TIME_UNIT_MINUTES.values()}
                                                        value={endDateTime.minute()}
                                                        onChange={this.handleChangeEndMinute}
                                                    />
                                                </div>
                                            </RowFlexContainer>
                                        </div>
                                    </FullWidthRowFlexContainer>
                                    <FormErrorMessage messages={errorMessage ? [{message: errorMessage}] : undefined}/>
                                </FullWidthLeftColumnFlexContainer>
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>予約タイトル</TableRowName>
                            <TableCell>
                                <PPTextField
                                    fullWidth
                                    onChange={this.handleChangeReserveTitle}
                                    value={reservationTitle}
                                    InputProps={{
                                        inputProps: {
                                            maxLength: 30,
                                        },
                                    }}
                                />
                                {classification === ReservationClass.MANAGER &&
                                    <div>{Messages.IFACA0039.toString()}</div>
                                }
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableRowName>予約種別</TableRowName>
                            <TableCell>
                                {reservationType ? reservationType.label : '-'}
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </Box>
        </>
    }
}

export default ARSelectFacilityInputFormDuration

const convertToErrorMessage = (errorType: Optional<string>): Optional<string> => {
    switch (errorType) {
        case 'illegal':
            return '利用終了日時が開始日時より前の日時になっています。'
        case 'overlap':
            return '指定した日時は予約できません。'
    }
    return undefined
}
